<div [class]="size + '-page'">
  <ng-content></ng-content>
</div>

